import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { Form, Button, FormGroup, FormControl, ControlLabel, InputGroup } from "react-bootstrap";
import Cookies, { set } from "js-cookie";
import { connect } from "react-redux";
import { signIn, cekCookies } from "../../actions";
import LoaderModal from "../modal/LoaderModal";
import { Link } from "react-router-dom";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      type: "password",
      icone: "fa fa-eye",
      password: "null",
    };
  }

  async componentDidMount() {
    this.setState({ isFetching: true });
    const n = await this.props.cekCookies("login");
    this.setState({ isFetching: false });
  }

  componentDidUpdate() {}

  renderError({ error, touched }) {
    if (touched && error) {
      return <small>{error}</small>;
    }
  }

  renderInput = ({ input, label, meta, type, placeholder }) => {
    return (
      <div className="form-group">
        <input {...input} type={type} className="form-control" placeholder={placeholder} />
        {this.renderError(meta)}
      </div>
    );
  };

  submitLogin = async (formValues) => {
    const type = document.getElementById("account").value;
    let formData = new FormData();
    formData.append("grant_type", "password");
    formData.append("username", type + "&" + formValues.username);
    // formData.append('password', formValues.password)
    formData.append("password", this.state.password);

    this.setState({ isFetching: true });
    await this.props.signIn(formData);
    this.setState({ isFetching: false });
  };

  renderAlert = () => {
    if (this.props.fetchError) {
      if (this.props.fetchError.type === "error") {
        return <div className="text-center">{this.props.fetchError.message != "Not authorized" && this.props.fetchError.message}</div>;
      }
    }
  };

  pwOnChange = async (e) => {
    this.setState({ password: e.target.value });
  };
  handleClick = () =>
    this.setState(({ type }) => ({
      type: type === "text" ? "password" : "text",
      icone: type === "text" ? "fa fa-eye" : "fa fa-eye-slash",
    }));

  render() {
    const loginBg = {
      height: "100vh",
      backgroundImage: "linear-gradient(to top, #09203f 0%, #537895 100%)",
    };
    return (
      <div className="container-fluid">
        <div className="row justify-content-md-center" style={loginBg}>
          <LoaderModal isFetching={this.state.isFetching} />
          <div className="col-lg-4 my-auto">
            {/* <div className="text-center" style={{ paddingBottom: "50px" }}>
              <img alt="Eduprime Logo" style={{ width: "50%" }} src="https://eduprime.co.id/static/images/LogoEduprimePutih.png" />
            </div> */}
            <div className="card" style={{ backgroundColor: "rgba(237,240,243,1)", border: "none" }}>
              <div className="carh-header">
                <div className="text-center" style={{ paddingTop: "20px" }}>
                  <img alt="Eduprime Logo" style={{ width: "60%" }} src="https://eduprime.co.id/static/images/LogoEduprimePutih.png" />
                </div>
              </div>
              <div className="card-body">
                <form onSubmit={this.props.handleSubmit(this.submitLogin)}>
                  <div className="row">
                    <div className="col-lg-12">
                      <Field name="username" component={this.renderInput} label="Username" type="text" placeholder="Username" />
                      {/* <Field type="text" name="password" component={this.renderInput} label="Password" placeholder="Password" value={this.state.password}/> */}
                      <input type="hidden" name="password" value={this.state.password} />

                      {/*  <div className="input-group">
                                                <Field type={this.state.type} id="password" name="password" class="form-control" placeholder="Password" component={this.renderInput}/>
                                                <span className="input-group-btn" onClick={this.handleClick}>
                                                    <button className="btn btn-default" type="button"><i className={this.state.icone}></i></button>
                                                </span>           
                                            </div> */}
                      <InputGroup className="mb-3">
                        <FormControl type={this.state.type} component={this.renderInput} placeholder="Password" onChange={this.pwOnChange} />
                        <InputGroup.Append>
                          <InputGroup.Text onClick={this.handleClick}>
                            {" "}
                            <a className={this.state.icone}></a>
                          </InputGroup.Text>
                        </InputGroup.Append>
                      </InputGroup>
                      <div className="form-group">
                        <select className="form-control" name="account" id="account" required>
                          <option value="admin">Sekolah / Dinas</option>
                          <option value="guru">Guru</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      {/* <Link to="/register-psep">Registrasi Akun</Link> */}
                      {/* <Link to="/forgot-password?idSekolah=333&token=abc">&nbsp;&nbsp;&nbsp;</Link> */}
                    </div>
                    <div className="col-lg-12" style={{ paddingTop: "10px" }}>
                      {this.renderAlert()}
                    </div>
                    <div className="col-lg-12" style={{ paddingTop: "10px" }}>
                      <button className="btn btn-primary" style={{ width: "100%" }}>
                        Login
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = (formValues) => {
  const errors = {};
  if (!formValues.username) {
    errors.username = "Anda harus memasukkan username";
  }
  if (!formValues.password) {
    errors.password = "Anda harus memasukkan password";
  }
  return errors;
};

const mapStateToProps = (state) => {
  return {
    account: state.account,
    fetchError: state.error,
  };
};

const formWrapped = reduxForm({
  form: "login",
  validate,
})(Login);

export default connect(mapStateToProps, { signIn, cekCookies })(formWrapped);
